import { render, staticRenderFns } from "./external.vue?vue&type=template&id=55fca731&scoped=true&lang=pug&"
import script from "./external.vue?vue&type=script&lang=js&"
export * from "./external.vue?vue&type=script&lang=js&"
import style0 from "./external.vue?vue&type=style&index=0&id=55fca731&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fca731",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('55fca731', component.options)
    } else {
      api.reload('55fca731', component.options)
    }
    module.hot.accept("./external.vue?vue&type=template&id=55fca731&scoped=true&lang=pug&", function () {
      api.rerender('55fca731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/component_library/external.vue"
export default component.exports